import styled from 'styled-components';

export const Button = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #000 !important;
  margin: 0px 10px 0px 20px;
  :focus {
    box-shadow: none;
  }

  svg {
    font-size: 20px !important;
  }
`;
